import React from 'react';

const Services = () => {
  return (
    <section className="section">
      <div className="container">
        <div className="service-header">
          <h2>We are the matchmakers and the missing piece. Uniting the world of culinary excellence with restaurants and customers.</h2>
          <p>We are a full-service restaurant marketing agency based in New York. Our team has extensive experience in identifying, vetting, and working with top restaurants across various cuisines and dining experiences. From fine dining to casual eateries, we have the expertise to help your restaurant succeed in the competitive food industry.</p>
        </div>
        
        <div className="service-features">
          <h3>We thoughtfully curate and customize each of our services to serve our community of restaurants, chefs, and food enthusiasts.</h3>
          <div className="features-grid">
            <div className="feature-item">
              <h4>High Quality Marketing, Every Time</h4>
              <p>Professional marketing strategies that showcase your restaurant's unique identity</p>
            </div>
            <div className="feature-item">
              <h4>Dedicated Success Managers</h4>
              <p>Personal account managers focused on your restaurant's growth and success</p>
            </div>
            <div className="feature-item">
              <h4>Get Real-Time Visibility Of Projects</h4>
              <p>Track your marketing campaigns and customer engagement in real-time</p>
            </div>
          </div>
        </div>

        <div className="service-pillars">
          <div className="pillar">
            <h3>Community</h3>
            <p>Building strong connections between restaurants and local communities</p>
          </div>
          <div className="pillar">
            <h3>Engagement</h3>
            <p>Creating meaningful interactions that drive customer loyalty</p>
          </div>
          <div className="pillar">
            <h3>Growth</h3>
            <p>Scaling your restaurant business with data-driven strategies</p>
          </div>
        </div>

        <div className="service-cta">
          <h2>Join the Restaurant Marketing Revolution</h2>
          <p>Access to top restaurant marketing strategies instantly</p>
          <a href="/contact" className="btn">Get Started Today</a>
        </div>

        <div className="service-expertise">
          <h2>For restaurants seeking to scale their business, we handpick the right marketing strategies</h2>
          <p>Having worked with some noteworthy restaurants across the fine dining, casual, fast-casual, and specialty cuisine industry, our expertise lies in serving innovative ideas with exciting concepts that align seamlessly with each restaurant's vision.</p>
          <p>Let us help you tell your restaurant's story and engage your audience in a meaningful way. Contact us to learn more about how we can help your restaurant reach its full potential.</p>
        </div>

        <div className="service-final">
          <h2>We help create marketing that makes your audience fall in ❤️ with your restaurant</h2>
          <h3>Don't be a Stranger. . . Just say Hello 👋</h3>
          <a href="/contact" className="btn">Get in touch!</a>
        </div>
      </div>
    </section>
  );
};

export default Services;
